export default __webpack_public_path__ + "static/media/react-ssr-thumb.f873a368.png";